// antd 组件国际化
import zh_CN_antd from 'antd/lib/locale-provider/zh_CN';
import en_US_antd from 'antd/lib/locale-provider/en_US';
// 本地组件国际化
import zh_CN from './zh-CN';
import en_US from './en-US';

/**
 * 获取国际化所需要的 locales
 * @param {string} language 语言
 * @returns
 */
export const getLocales = (
  language = '中文',
  extraMessages = {
    zh: {},
    en: {}
  }
) => {
  let localeAntd = zh_CN_antd;
  let intlLocales = getIntlLocales('zh', { ...zh_CN, ...extraMessages.zh });
  if (language === 'English') {
    localeAntd = en_US_antd;
    intlLocales = getIntlLocales('en', { ...en_US, ...extraMessages.en });
  }
  return { ...intlLocales, localeAntd };
};

export const getIntlLocales = (lang = 'zh', extraMessages = {}) => {
  let locale = '';
  let messages = {};
  switch (lang) {
    case 'zh': {
      locale = 'zh';
      messages = zh_CN;
      break;
    }
    case 'en': {
      locale = 'en';
      messages = en_US;
      break;
    }
    default: {
      locale = 'zh';
      messages = zh_CN;
    }
  }
  return { locale, messages: { ...messages, ...extraMessages } };
};
